import React from "react";
import classNames from "classnames";
import { getDisplayValues } from "./utils";
import styles from "../styles.scss";

interface CountdownTimerProps {
  countdownSeconds: number;
  className?: string;
}
export const CountdownTimer = ({
  countdownSeconds,
  className,
}: CountdownTimerProps): React.ReactElement => {
  let message;
  try {
    const [minutes, seconds] = getDisplayValues(countdownSeconds);
    if (minutes + seconds <= 0) {
      message = `Code has expired.`;
    } else {
      let formattedMinutes;
      let formattedSeconds;
      if (minutes < 10) {
        formattedMinutes = `0${minutes}`;
      } else {
        formattedMinutes = `${minutes}`;
      }
      if (seconds < 10) {
        formattedSeconds = `0${seconds}`;
      } else {
        formattedSeconds = `${seconds}`;
      }
      message = `Code will expire in ${formattedMinutes}:${formattedSeconds}.`;
    }
  } catch (e) {
    message = `Code will expire in 5 minutes.`;
  }
  return (
    <span
      className={classNames(
        className,
        styles.VerifyTwoFAForm__timerText,
        "text-sm secondary stacked-md",
      )}
      data-testid="two-fa-timer"
    >
      {message}
    </span>
  );
};
